import {
    takeEvery,
    call,
    all,
    put,
    fork,
} from 'redux-saga/effects';

import { types, actions } from './reducer';
import TypeService from '@iso/services/SettingsService/OrderService/TypeService';
import { extractError } from '@iso/lib/helpers/api';

function* submitOrderType({ id, data }) {
    try {
        let response;
        if(id) {
            response = yield call(TypeService.editOrderType, id, data);
        } else {
            response = yield call(TypeService.addOrderType, data);
        }
        yield put(actions.submitOrderTypeSucceeded(response.data));
    } catch (error) {
        yield put(actions.submitOrderTypeFailed(extractError(error)));
    }
}

function* watchSubmitOrderType() {
    yield takeEvery(
        types.REQUEST_SUBMIT_ORDER_TYPE,
        submitOrderType,
    );
}

function* createSaga() {
    yield all([
        fork(watchSubmitOrderType),
    ]);
}

export default createSaga;